'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('e-form-editor', {
      url: '/e-form/edit/:id',
      template: '<e-form-edit></e-form-edit>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/e-form/edit/e-form-editor.routes.js